var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"float-right pr-1"},[(_vm.a == _vm.b)?_c('font-awesome-icon',{staticClass:"my-auto mx-1.5 text-orange-200",attrs:{"icon":['fas', 'folder-open'],"size":"lg"}}):_c('font-awesome-icon',{staticClass:"my-auto mx-1.5 text-gray-200",attrs:{"icon":['fas', 'folder'],"size":"lg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }